module.exports = __webpack_public_path__ + "img/logo_banana_white.77914ba1.svg";